module.exports = __webpack_public_path__ + "src/img/upward_green.37681224.svg";